/*
 * Customaly favorites (wishlist). Original work.
 *
 * localStorage-backed, key 'cuFavorites' - kept identical to the previous
 * theme so existing customers keep their saved items across the theme swap.
 */
(function () {
  var favoritesKey = 'cuFavorites'
  var transientFavorites = []

  function normalizeFavoritePrice(value) {
    var decoder = document.createElement('textarea')

    decoder.innerHTML = String(value || '')

    return decoder.value
      .replace(/<[^>]*>/g, '')
      .replace(/\s+/g, ' ')
      .trim()
  }

  function readFavorites() {
    try {
      var storedValue = window.localStorage.getItem(favoritesKey)

      if (storedValue === null) {
        return transientFavorites
      }

      var storedFavorites = JSON.parse(storedValue)

      if (!Array.isArray(storedFavorites)) {
        return []
      }

      transientFavorites = storedFavorites
        .filter(function (item) {
          return item && item.id && item.url && item.title
        })
        .slice(0, 50)
        .map(function (item) {
          item.price = normalizeFavoritePrice(item.price)
          return item
        })
      return transientFavorites
    } catch (error) {
      return transientFavorites
    }
  }

  function writeFavorites(favorites) {
    transientFavorites = favorites.slice(0, 50)

    try {
      window.localStorage.setItem(favoritesKey, JSON.stringify(transientFavorites))
    } catch (error) {
      // Favorites continue to work for the current page when storage is unavailable.
    }
  }

  function productFromFavoriteButton(button) {
    return {
      id: button.getAttribute('data-cu-favorite-id'),
      url: button.getAttribute('data-cu-favorite-url'),
      title: button.getAttribute('data-cu-favorite-title'),
      image: button.getAttribute('data-cu-favorite-image'),
      price: normalizeFavoritePrice(button.getAttribute('data-cu-favorite-price'))
    }
  }

  function createFavoritePreviewItem(item) {
    var row = document.createElement('div')
    var link = document.createElement('a')
    var imageWrap = document.createElement('span')
    var details = document.createElement('span')
    var title = document.createElement('strong')
    var price = document.createElement('small')
    var removeButton = document.createElement('button')

    row.className = 'cu-mini-favorites__row'
    link.className = 'cu-mini-cart__item cu-mini-favorites__item'
    link.href = item.url
    imageWrap.className = 'cu-mini-cart__image'
    details.className = 'cu-mini-cart__details'
    title.textContent = item.title
    price.className = 'money'
    price.textContent = normalizeFavoritePrice(item.price)
    removeButton.type = 'button'
    removeButton.className = 'cu-mini-favorites__remove'
    removeButton.setAttribute('data-cu-favorite-remove', item.id)
    removeButton.setAttribute('aria-label', 'Remove ' + item.title + ' from favorites')
    removeButton.textContent = '×'

    if (item.image) {
      var image = document.createElement('img')
      image.src = item.image.indexOf('//') === 0 ? 'https:' + item.image : item.image
      image.alt = ''
      image.loading = 'lazy'
      imageWrap.appendChild(image)
    }

    details.append(title, price)
    link.append(imageWrap, details)
    row.append(link, removeButton)

    return row
  }

  function updateFavoriteInterface() {
    var favorites = readFavorites()
    var favoriteIds = favorites.map(function (item) {
      return String(item.id)
    })

    document.querySelectorAll('[data-cu-favorite-toggle]').forEach(function (button) {
      var isFavorite = favoriteIds.indexOf(String(button.getAttribute('data-cu-favorite-id'))) !== -1
      var title = button.getAttribute('data-cu-favorite-title') || 'this product'

      button.classList.toggle('is-active', isFavorite)
      button.setAttribute('aria-pressed', isFavorite ? 'true' : 'false')
      button.setAttribute(
        'aria-label',
        (isFavorite ? 'Remove ' : 'Add ') + title + (isFavorite ? ' from favorites' : ' to favorites')
      )
    })

    document.querySelectorAll('[data-cu-favorites-count]').forEach(function (count) {
      count.textContent = favorites.length
      count.hidden = favorites.length === 0
    })

    document.querySelectorAll('[data-cu-favorites-popover]').forEach(function (popover) {
      var items = popover.querySelector('[data-cu-favorites-items]')
      var empty = popover.querySelector('[data-cu-favorites-empty]')
      var footer = popover.querySelector('[data-cu-favorites-footer]')
      var total = popover.querySelector('[data-cu-favorites-total]')
      var footerCount = popover.querySelector('[data-cu-favorites-footer-count]')
      var isEmpty = favorites.length === 0

      if (!items || !empty || !footer || !total || !footerCount) {
        return
      }

      items.replaceChildren()
      favorites.slice(0, 5).forEach(function (item) {
        items.appendChild(createFavoritePreviewItem(item))
      })
      total.textContent = favorites.length
      footerCount.textContent = favorites.length
      items.hidden = isEmpty
      empty.hidden = !isEmpty
      footer.hidden = isEmpty
    })

    document.dispatchEvent(new CustomEvent('cu:favorites:updated', {
      detail: { favorites: favorites }
    }))
  }

  function toggleFavorite(button) {
    var product = productFromFavoriteButton(button)
    var favorites = readFavorites()
    var existingIndex = favorites.findIndex(function (item) {
      return String(item.id) === String(product.id)
    })

    if (existingIndex === -1) {
      favorites.unshift(product)
    } else {
      favorites.splice(existingIndex, 1)
    }

    writeFavorites(favorites)
    updateFavoriteInterface()
  }

  function removeFavorite(productId) {
    var favorites = readFavorites().filter(function (item) {
      return String(item.id) !== String(productId)
    })

    writeFavorites(favorites)
    updateFavoriteInterface()
  }

  function closeFavoritesMenus(exception) {
    document.querySelectorAll('.cu-favorites-menu.is-open').forEach(function (menu) {
      if (menu === exception) {
        return
      }

      menu.classList.remove('is-open')
      var trigger = menu.querySelector('[data-cu-favorites-trigger]')
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false')
      }
    })
  }

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-cu-favorite-remove]')

    if (removeButton) {
      event.preventDefault()
      removeFavorite(removeButton.getAttribute('data-cu-favorite-remove'))
      return
    }

    var favoriteButton = event.target.closest('[data-cu-favorite-toggle]')

    if (favoriteButton) {
      event.preventDefault()
      toggleFavorite(favoriteButton)
      return
    }

    var favoritesTrigger = event.target.closest('[data-cu-favorites-trigger]')

    if (favoritesTrigger) {
      var menu = favoritesTrigger.closest('.cu-favorites-menu')
      var willOpen = !menu.classList.contains('is-open')

      closeFavoritesMenus(menu)
      menu.classList.toggle('is-open', willOpen)
      favoritesTrigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false')
      return
    }

    if (!event.target.closest('.cu-favorites-menu')) {
      closeFavoritesMenus()
    }
  })

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeFavoritesMenus()
    }
  })

  // Sync across tabs.
  window.addEventListener('storage', function (event) {
    if (event.key === favoritesKey) {
      transientFavorites = []
      updateFavoriteInterface()
    }
  })

  document.addEventListener('DOMContentLoaded', updateFavoriteInterface)
  document.addEventListener('shopify:section:load', updateFavoriteInterface)
})()
